import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {FormOption} from "../../../tandem-core/components/forms/form-option";

@Component({
  selector: 'tandem-csv-mapping',
  templateUrl: './csv-mapping.component.html',
  styleUrls: ['./csv-mapping.component.scss']
})
export class CsvMappingComponent implements OnInit, AfterViewInit {

  parsedOutput: {columnHeaders: string[], data: any[]} = {columnHeaders: [], data: []}
  options: FormOption[] = [];
  mappingForm: FormGroup = new FormGroup<any>({});
  errorMessage?: string;
  public modalRef?: ModalRef;
  nameText: string = "Name or description of the transaction";
  valueText: string = "The amount of the transaction";
  dateText: string =  "When the transaction occurred";
  invertAmountText: string =  "Generally used while mapping credit card statements";

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.options = this.parsedOutput.columnHeaders.map(header => {
      return {
        label: header,
        value: header,
      }
    });
    this.mappingForm = this.fb.group({
      name: [null, Validators.required],
      value: [null, Validators.required],
      date: [null, Validators.required],
      invertAmounts: [false],
    });
    this.mappingForm.valueChanges.subscribe(val => {
      this.errorMessage = undefined;
    })
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  public onSubmit() {
    if (this.mappingForm.get('name')?.value === this.mappingForm.get('value')?.value
    || this.mappingForm.get('name')?.value === this.mappingForm.get('date')?.value
    || this.mappingForm.get('value')?.value === this.mappingForm.get('date')?.value) {
      this.errorMessage = 'Whoops, you can\'t use the same column from your financial institution\'s output for multiple properties here.'
    } else {
      this.modalRef?.close(this.mappingForm.value);
    }
  }

  public onCancel() {
    this.modalRef?.close();
  }
}
